export default __webpack_public_path__ + "static/media/language-pl.ab4ec5d8.svg";